// extracted by mini-css-extract-plugin
module.exports = {"container":"Events_container__3zUn-","events":"Events_events__1hqd8","content":"Events_content__ZVyV9"};